import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../contextos/AuthContext";
import { estilosGrupos } from "../elementos/gruposEstilos";
import {
  abandonarGrupo,
  cargarGruposEstudiante,
  normalizarCodigo,
} from "../funciones/gruposServicio";

export default function EstudianteGrupos() {
  const navigate = useNavigate();
  const { usuario } = useAuth();

  const [codigo, setCodigo] = useState("");
  const [grupos, setGrupos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  const cargar = useCallback(async () => {
    if (!usuario) return;
    setError("");
    try {
      setGrupos(await cargarGruposEstudiante(usuario.uid));
    } catch (err) {
      console.error("Error cargando grupos del estudiante:", err);
      setError("No fue posible cargar tus grupos. Revisa la conexión e inténtalo de nuevo.");
    } finally {
      setCargando(false);
    }
  }, [usuario]);

  useEffect(() => {
    cargar();
  }, [cargar]);

  const usarCodigo = () => {
    const limpio = normalizarCodigo(codigo);
    if (limpio) navigate(`/unirse/${limpio}`);
  };

  const salir = async (grupo) => {
    const pendiente = grupo.membresia.estado === "pendiente";
    const pregunta = pendiente
      ? `¿Cancelar tu solicitud para "${grupo.nombre}"?`
      : `¿Salir de "${grupo.nombre}"? Tus profesores dejarán de ver tu progreso.`;

    if (!window.confirm(pregunta)) return;

    try {
      await abandonarGrupo(grupo.membresia.docId);
      await cargar();
    } catch (err) {
      console.error("Error saliendo del grupo:", err);
      setError("No fue posible completar la acción. Inténtalo de nuevo.");
    }
  };

  return (
    <div className="gg gg-pagina">
      <style>{estilosGrupos}</style>

      <header className="gg-encabezado">
        <div>
          <h1>Mis grupos</h1>
          <p className="gg-sutil">Los grupos te conectan con profesores que acompañan tu preparación.</p>
        </div>
      </header>

      <section className="gg-tarjeta" style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: "1rem" }}>¿Tienes un código de invitación?</h2>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <input
            className="gg-input"
            style={{ flex: "1 1 180px", textTransform: "uppercase", letterSpacing: "0.12em" }}
            value={codigo}
            onChange={(e) => setCodigo(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && usarCodigo()}
            placeholder="Ej. P9OGK3"
            aria-label="Código de invitación"
            maxLength={12}
          />
          <button type="button" className="gg-btn gg-btn--primario" onClick={usarCodigo}>
            Unirme
          </button>
        </div>
        <p className="gg-sutil">Tu profesor también puede enviarte un enlace o un código QR.</p>
      </section>

      {error && <p role="alert" className="gg-alerta">{error}</p>}
      {cargando && <p className="gg-sutil">Cargando tus grupos…</p>}

      {!cargando && !error && grupos.length === 0 && (
        <div className="gg-vacio">
          <p>Aún no perteneces a ningún grupo. Pídele a tu profesor un enlace o código de invitación.</p>
        </div>
      )}

      {grupos.length > 0 && (
        <div className="gg-grid">
          {grupos.map((grupo) => {
            const pendiente = grupo.membresia.estado === "pendiente";
            return (
              <article key={grupo.id} className="gg-tarjeta">
                <div className="gg-tarjeta__cabecera">
                  <h2 className="gg-tarjeta__nombre">{grupo.nombre}</h2>
                  <span className={`gg-insignia ${pendiente ? "gg-insignia--aviso" : "gg-insignia--exito"}`}>
                    {pendiente ? "Esperando aprobación" : "Activo"}
                  </span>
                </div>

                {grupo.descripcion && <p className="gg-sutil">{grupo.descripcion}</p>}

                <div>
                  <span className="gg-sutil">
                    {pendiente ? "Profesores del grupo" : "Profesores que siguen tu progreso"}
                  </span>
                  <p style={{ margin: "4px 0 0", fontWeight: 600 }}>
                    {grupo.profesores.length > 0 ? grupo.profesores.join(", ") : "—"}
                  </p>
                </div>

                <div className="gg-tarjeta__acciones">
                  <button type="button" className="gg-btn gg-btn--peligro" onClick={() => salir(grupo)}>
                    {pendiente ? "Cancelar solicitud" : "Salir del grupo"}
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}